module.exports = __webpack_public_path__ + "assets/1d67153fbdd2486394b2bab794d4a688.mp3";